import { Link } from "react-router-dom";
import ShellCard from "../../components/ShellCard";
import heroBanner from "../../assets/images/pages/dui-school-details.jpg";

const DuiSchoolDetails = () => {
  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">DUI School Details</h1>
              <p className="banner-subheading">Detailed Program Information</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5" style={{ backgroundColor: "#111111" }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ShellCard>
                <div className="mb-4">
                  <p className="text-white mb-0">
                    You have 90 days from your enrollment date to complete the
                    entire program (class and evaluation). Failure to do so will
                    result in notification of such to the Department of Highway
                    Safety and Motor Vehicles, and all fees paid will be
                    forfeited.
                  </p>
                </div>

                <div
                  className="p-3 rounded mb-4"
                  style={{
                    backgroundColor: "#333333",
                    border: "1px solid var(--metro-yellow)",
                  }}
                >
                  <p className="text-white mb-3">
                    Upon completing the registration and selecting your class
                    dates, you will also need to schedule your one-hour
                    evaluation. In order to choose a date and time for your
                    evaluation, we will need you to provide the following:
                  </p>

                  <ul className="text-white ps-3 mb-0">
                    <li className="mb-3">
                      <strong style={{ color: "var(--metro-yellow)" }}>
                        Legible copy of Police Report (Complaint Arrest
                        Affidavit):
                      </strong>{" "}
                      can be obtained from the arresting agency or attorney
                    </li>
                    <li className="mb-3">
                      <strong style={{ color: "var(--metro-yellow)" }}>
                        Legible copy of the DUI Ticket (Florida DUI Uniform
                        Citation):
                      </strong>{" "}
                      can be obtained from the Clerk of the Court in the county
                      of the arrest
                    </li>
                    <li className="mb-3">
                      <strong style={{ color: "var(--metro-yellow)" }}>Picture ID:</strong>{" "}
                      if your license is not from Florida, we will also need a
                      copy of your driving record for the state in which your
                      license was issued
                    </li>
                    <li className="mb-0">
                      <strong style={{ color: "var(--metro-yellow)" }}>
                        A Driver Risk Inventory questionnaire
                      </strong>{" "}
                      will need to be completed at any of our offices during its
                      respective hours of operation
                    </li>
                  </ul>
                </div>

                <div className="mb-4">
                  <p className="text-white mb-0">
                    Once we have all of the required documentation listed above,
                    you will be able to schedule your evaluation online. If you
                    feel the need to reschedule your evaluation, you can also do
                    so online.
                  </p>
                </div>

                <div className="mb-4">
                  <p className="text-white mb-0">
                    If you have any questions about the required documentation,
                    please feel free to contact our knowledgeable staff at{" "}
                    <a
                      href="tel:1-888-41-METRO"
                      className="text-decoration-none"
                      style={{ color: "var(--metro-yellow)" }}
                    >
                      1-888-41-METRO
                    </a>
                    . We will be more than happy to assist you!
                  </p>
                </div>

                <div className="mb-4">
                  <p className="text-white mb-0">
                    If you need to reschedule either your class or evaluation,
                    you should do so at least 5 days prior in order to avoid a
                    rescheduling fee. The rescheduling fee will also apply if
                    you are late to any of your appointments.
                  </p>
                </div>

                <div className="mb-4">
                  <p className="text-white mb-0">
                    The use of alcohol and/or controlled substances prior to
                    and/or during class or evaluation is prohibited. You may be
                    subject to a breath test prior to or during each class and
                    the evaluation. If the breath test is refused or results in
                    a positive sample, all fees will be forfeited, and you will
                    need to re-enroll to complete all parts of the program; even
                    those already completed.
                  </p>
                </div>

                <div className="mb-4">
                  <p className="text-white mb-2">
                    <strong>Please be advised:</strong>
                  </p>
                  <p className="text-white mb-0">
                    Information regarding drug and alcohol patient records is
                    protected by Federal Confidentiality Rules (42 CFR Part 2).
                    The Federal rules prohibit Metro Traffic School from making
                    any further disclosure of this information unless further
                    disclosure is expressly permitted by the written consent of
                    the person to whom it pertains or as otherwise permitted by
                    42 CFR Part 2.
                  </p>
                </div>

                <div className="mb-4">
                  <p className="text-white mb-0">
                    A general authorization for the release of medical or other
                    information is NOT sufficient for this purpose. The Federal
                    rules restrict any use of the information to criminally
                    investigate or prosecute any alcohol or drug abuse patient.
                  </p>
                </div>

                <div className="mb-5">
                  <p className="text-white mb-0">
                    To begin your online registration, please{" "}
                      <Link
                          to="https://dui.webwizardsusa.com/register"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none"
                          style={{ color: "var(--metro-yellow)" }}
                      >
                          "REGISTER NOW!"
                      </Link>
                  </p>
                </div>

                <div className="text-center">
                  <Link
                    to="https://dui.webwizardsusa.com/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-lg px-4 py-3 fw-bold text-dark metro-btn-primary text-decoration-none"
                    style={{
                      backgroundColor: "var(--metro-yellow)",
                      border: "none",
                    }}
                  >
                    <i className="fas fa-user-plus me-2"></i>
                    Register Now!
                  </Link>
                </div>
              </ShellCard>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DuiSchoolDetails;
